"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
var endpoint = "/api/explorer-view";
exports.endpoints = {
    searchSocialUsersExplorer: "".concat(endpoint, "/users"),
    searchModulesExplorer: "".concat(endpoint, "/modules"),
    searchGroupsExplorer: "".concat(endpoint, "/groups"),
    getExplorerPresets: "/api/user-custom-columns/index",
    explorerPresetUpdate: function (id) { return "/api/user-custom-columns/".concat(id, "/update"); },
    explorerPresetRemove: function (id) { return "/api/user-custom-columns/".concat(id, "/delete"); },
    explorerPresetGet: function (id) { return "".concat(endpoint, "/presets/").concat(id); },
    explorerPresetCreate: "/api/user-custom-columns/create",
};
